import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createContext, useContext, useState, useEffect, useRef, useMemo } from 'react';
import { createError } from '@dotlottie/common';

function x() {
  var e = useRef(!0);
  return e.current ? (e.current = !1, !0) : e.current;
}

var T = function T(e, o) {
  var t = x();
  useEffect(function () {
    if (!t) return e();
  }, o);
},
    P = T;

var c = function c() {};

function m(e) {
  for (var o = [], t = 1; t < arguments.length; t++) {
    o[t - 1] = arguments[t];
  }

  e && e.addEventListener && e.addEventListener.apply(e, o);
}

function d(e) {
  for (var o = [], t = 1; t < arguments.length; t++) {
    o[t - 1] = arguments[t];
  }

  e && e.removeEventListener && e.removeEventListener.apply(e, o);
}

var v = typeof window < "u";

var w = ["mousedown", "touchstart"],
    D = function D(e, o, t) {
  t === void 0 && (t = w);
  var r = useRef(o);
  useEffect(function () {
    r.current = o;
  }, [o]), useEffect(function () {
    for (var u = function u(a) {
      var s = e.current;
      s && !s.contains(a.target) && r.current(a);
    }, f = 0, n = t; f < n.length; f++) {
      var p = n[f];
      m(document, p, u);
    }

    return function () {
      for (var a = 0, s = t; a < s.length; a++) {
        var l = s[a];
        d(document, l, u);
      }
    };
  }, [t, e]);
},
    F = D;

var b = v ? window : null,
    y = function y(e) {
  return !!e.addEventListener;
},
    L = function L(e) {
  return !!e.on;
},
    B = function B(e, o, t, r) {
  t === void 0 && (t = b), useEffect(function () {
    if (o && t) return y(t) ? m(t, e, o, r) : L(t) && t.on(e, o, r), function () {
      y(t) ? d(t, e, o, r) : L(t) && t.off(e, o, r);
    };
  }, [e, o, t, JSON.stringify(r)]);
},
    E = B;

var H = function H(e) {
  return typeof e == "function" ? e : typeof e == "string" ? function (o) {
    return o.key === e;
  } : e ? function () {
    return !0;
  } : function () {
    return !1;
  };
},
    U = function U(e, o, t, r) {
  o === void 0 && (o = c), t === void 0 && (t = {}), r === void 0 && (r = [e]);
  var u = t.event,
      f = u === void 0 ? "keydown" : u,
      n = t.target,
      p = t.options,
      a = useMemo(function () {
    var s = H(e),
        l = function l(i) {
      if (s(i)) return o(i);
    };

    return l;
  }, r);
  E(f, a, n, p);
},
    A = U;

var C = createContext(null),
    de = C.Provider,
    pe = function pe() {
  var e = useContext(C);
  if (typeof e > "u") throw createError("useDotLottieContext must be used within a DotLottieProvider");
  return e;
};

var ve = function ve(e, o, t) {
  var _useState = useState(function () {
    return t();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      r = _useState2[0],
      u = _useState2[1];

  return useEffect(function () {
    var f = e(function () {
      var n = o();
      u(n);
    });
    return function () {
      f();
    };
  }, [e]), r;
};

export { P as a, F as b, A as c, ve as d, de as e, pe as f };